// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "37f84ddb18da2f87f963c" + ".chunk.js";
};